import { cx } from 'class-variance-authority';
import { ClassValue } from 'class-variance-authority/dist/types';

import { customTwMerge } from '@/app/utils/custom-tw-merge';

export function cn(...args: ClassValue[]) {
  return customTwMerge(cx(args));
}
